class CustomModelDialog {
  constructor(onSubmit) {
    this.onSubmit = onSubmit;
    this.dialog = null;
    this.form = null;
    this.fileInput = null;
  }
  
  show() {
    this.createDialog();
    this.dialog.style.display = 'flex';
  }
  
  hide() {
    if (this.dialog) {
      this.dialog.style.display = 'none';
    }
  }
  
  createDialog() {
    if (this.dialog) {
      this.dialog.style.display = 'flex';
      return;
    }
    
    // Overlay
    this.dialog = document.createElement('div');
    this.dialog.className = 'dialog-overlay';
    
    // Dialog container
    const container = document.createElement('div');
    container.className = 'dialog-container';
    
    // Titolo
    const title = document.createElement('h2');
    title.className = 'dialog-title';
    title.textContent = 'Carica Modello Custom';
    
    // Form
    this.form = document.createElement('form');
    this.form.className = 'dialog-form';
    
    // File input
    const fileGroup = this.createFormGroup(
      'File GLTF',
      'file',
      'file',
      'Seleziona file .glb o .gltf',
      true
    );
    this.fileInput = fileGroup.querySelector('input');
    this.fileInput.accept = '.glb,.gltf';
    
    // Input nome
    const nameGroup = this.createFormGroup(
      'Nome Mobile',
      'text',
      'name',
      'es. Divano Moderno',
      true
    );
    
    // Dimensioni
    const dimsTitle = document.createElement('div');
    dimsTitle.className = 'dimensions-title';
    dimsTitle.textContent = 'Dimensioni (metri)';
    
    const dimsContainer = document.createElement('div');
    dimsContainer.className = 'dimensions-container';
    
    // Larghezza × Profondità × Altezza
    const widthGroup = this.createFormGroup('Larghezza', 'number', 'width', '1.0', false, '0.01');
    const depthGroup = this.createFormGroup('Profondità', 'number', 'depth', '1.0', false, '0.01');
    const heightGroup = this.createFormGroup('Altezza', 'number', 'height', '1.0', false, '0.01');
    
    dimsContainer.appendChild(widthGroup);
    dimsContainer.appendChild(depthGroup);
    dimsContainer.appendChild(heightGroup);
    
    // Opzioni snap
    const snapGroup = document.createElement('div');
    snapGroup.className = 'checkbox-group';
    
    const snapToWallCheck = this.createCheckbox('Snap alla parete', 'snapToWall', false);
    const snapToGridCheck = this.createCheckbox('Snap alla griglia', 'snapToGrid', false);
    
    snapGroup.appendChild(snapToWallCheck);
    snapGroup.appendChild(snapToGridCheck);
    
    // Bottoni
    const buttonsContainer = document.createElement('div');
    buttonsContainer.className = 'dialog-buttons';
    
    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.textContent = 'Annulla';
    cancelButton.className = 'dialog-button cancel';
    cancelButton.addEventListener('click', () => this.hide());
    
    const submitButton = document.createElement('button');
    submitButton.type = 'submit';
    submitButton.textContent = 'Carica Modello';
    submitButton.className = 'dialog-button submit';
    
    buttonsContainer.appendChild(cancelButton);
    buttonsContainer.appendChild(submitButton);
    
    // Assembla il form
    this.form.appendChild(fileGroup);
    this.form.appendChild(nameGroup);
    this.form.appendChild(dimsTitle);
    this.form.appendChild(dimsContainer);
    this.form.appendChild(snapGroup);
    this.form.appendChild(buttonsContainer);
    
    // Invio del form
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
    
    // Assembla dialog
    container.appendChild(title);
    container.appendChild(this.form);
    this.dialog.appendChild(container);
    
    // Chiude su overlay click
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        this.hide();
      }
    });
    
    document.body.appendChild(this.dialog);
  }
  
  createFormGroup(label, type, name, placeholder, required = false, step = null) {
    const group = document.createElement('div');
    group.className = 'form-group';
    
    const labelEl = document.createElement('label');
    labelEl.textContent = label;
    
    const input = document.createElement('input');
    input.type = type;
    input.name = name;
    input.placeholder = placeholder;
    if (step) input.step = step;
    
    group.appendChild(labelEl);
    group.appendChild(input);
    
    return group;
  }
  
  createCheckbox(label, name, checked = false) {
    const container = document.createElement('label');
    container.className = 'checkbox-label';
    
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.name = name;
    checkbox.checked = checked;
    
    const labelText = document.createElement('span');
    labelText.textContent = label;
    
    container.appendChild(checkbox);
    container.appendChild(labelText);
    
    return container;
  }
  
  async handleSubmit() {
    const formData = new FormData(this.form);
    const file = this.fileInput.files[0];
    
    if (!file) {
      alert('Seleziona un file GLTF');
      return;
    }
    
    // Validazione grandezza del file
    if (file.size > 50 * 1024 * 1024) {
      alert('Il file è troppo grande (max 50MB)');
      return;
    }
    
    const metadata = {
      name: formData.get('name'),
      width: formData.get('width'),
      height: formData.get('height'),
      depth: formData.get('depth'),
      snapToWall: formData.get('snapToWall') === 'on',
      snapToGrid: formData.get('snapToGrid') === 'on',
      rotationStep: 45
    };
    
    // Validazione manuale con alert "Obbligatorio"
    if (!metadata.name || metadata.name.trim() === '') {
      alert('Obbligatorio: Nome Mobile');
      return;
    }
    
    if (!metadata.width || metadata.width === '') {
      alert('Obbligatorio: Larghezza');
      return;
    }
    
    if (!metadata.height || metadata.height === '') {
      alert('Obbligatorio: Altezza');
      return;
    }
    
    if (!metadata.depth || metadata.depth === '') {
      alert('Obbligatorio: Profondità');
      return;
    }
    
    // Validazione valori numerici
    if (parseFloat(metadata.width) <= 0 || parseFloat(metadata.height) <= 0 || parseFloat(metadata.depth) <= 0) {
      alert('Le dimensioni devono essere maggiori di zero');
      return;
    }
    
    try {
      // Mostra loading
      const submitBtn = this.form.querySelector('.dialog-button.submit');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Caricamento...';
      submitBtn.disabled = true;
      
      // Chiama callback
      await this.onSubmit(file, metadata);
      
      // Reset form e chiude
      this.form.reset();
      this.hide();
      
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    } catch (error) {
      alert('Errore durante il caricamento: ' + error.message);
      
      const submitBtn = this.form.querySelector('.dialog-button.submit');
      submitBtn.textContent = 'Carica Modello';
      submitBtn.disabled = false;
    }
  }
  
  dispose() {
    if (this.dialog && this.dialog.parentNode) {
      this.dialog.parentNode.removeChild(this.dialog);
    }
  }
}

export default CustomModelDialog;